import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { monitoringService } from '@/api/services/monitoring';
import { platformService } from '@/api/services/platform';
import { isClusterHybridCloud } from '@/utils/cluster-utils';

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId/_tabs/logs')({
  beforeLoad: async ({ context: { queryClient, clusterQuery }, params }) => {
    const clusterData = await queryClient.fetchQuery(clusterQuery);
    const cluster = clusterData.cluster;

    const { accountId, clusterId } = params;
    if (!isClusterHybridCloud(cluster)) {
      return {
        hybridCloudEnvDetailsQueryOptions: null,
        clusterEventsOptions: null,
      };
    }

    return {
      hybridCloudEnvDetailsQueryOptions: platformService.getCloudProviderRegionQuery({
        accountId,
        regionId: cluster.cloudProviderRegionId,
        cloudProviderId: cluster.cloudProviderId,
      }),
      clusterEventsOptions: monitoringService.getClusterEventsQuery({
        accountId,
        clusterId,
      }),
    };
  },

  loader({ context: { queryClient, clusterEventsOptions, hybridCloudEnvDetailsQueryOptions } }) {
    // When it's a hybrid cloud environment we need both the hybrid cloud env details and the events logs
    if (hybridCloudEnvDetailsQueryOptions) {
      void queryClient.prefetchQuery(hybridCloudEnvDetailsQueryOptions);
      void queryClient.prefetchQuery(clusterEventsOptions);
    }
  },
  component: lazyRouteComponent(() => import('./logs.component'), 'LogsComponent'),
});
